import { STATUS } from './signup';
/*
export class RegistrationEvent{
    cors = ["unknown"];
    docid: string;
    title: string;
    fromdate: Date;
    todate: Date;
    status = STATUS.NEW;
    personid: string;
    spphone: string;
    spname: string;
    allowedcount = 100;
    cachestatus = false;
    firstexpiration = 0;
    lastupdatetime = 0;
   // pl: string;
    constructor(id: string){
        this.personid = id;
       // this.pl = "none";
    }
 }
    */
export class RegistrationEvent{
    allowedcount = 100;
    personid: string;
    fromdate: Date;
    todate: Date;
    bk: string;
    spname: string;
    lastupdatetime: number;
    pl: string = "";
    spphone: string;
    spemail: string;
    status: number;
    cachestatus: boolean = false;;
    docid: string;
    eventid: string;
    firstexpiration: number;
    title: string;
    constructor(id: string){
        this.personid = id;
        this.status = 0;
        this.firstexpiration = 0;
        this.fromdate = new Date();
        this.todate = this.fromdate;
    }
}
